import React, { useEffect, useState } from "react";
import "./image-carousel.css";
import leftChevron from "../../../assets/images/chevron_left.png";
import rightChevron from "../../../assets/images/chevron_right.png";
import { LogEvent } from "../../../utils/EventLogging";

function ImageCarousel(props) {
  const [images] = useState(props.images || []);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    // Hide shade immediately since it's no longer managed via legacy manual DOM manipulation
    let shade = document.querySelector(`#${props.id}-blackout-shade`);
    if (shade) {
      shade.style.display = "none";
    }
  }, [props.id]);

  if (!images || images.length === 0) return null;

  const next = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
    LogEvent(`${props.projectName}Showcase:nextImage`);
  };

  const previous = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
    LogEvent(`${props.projectName}Showcase:previousImage`);
  };

  return (
    <section id={props.id} className="image-carousel">
      {/* Previous Button */}
      <button
        disabled={images.length <= 1}
        onClick={previous}
        className="image-carousel-button btn-left"
      >
        <img src={leftChevron} alt="previous button" />
      </button>

      <div id={props.id + "-viewport"} className="carousel-viewport" style={{ position: "relative" }}>
        {/* Legacy Blackout Shade (Hidden) */}
        <div id={props.id + "-blackout-shade"} className="shade" style={{ display: "none" }}></div>

        {images.map((img, idx) => {
          let offset = idx - activeIndex;

          // Infinite Wrap Logic
          if (images.length > 2) {
            if (offset < -1) offset += images.length;
            if (offset > 1) offset -= images.length;
          }

          let translateX = offset * 100;
          let opacity = Math.abs(offset) > 1 && images.length > 2 ? 0 : 1;

          return (
            <div
              key={idx}
              className="viewport-image-container"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                transform: `translateX(${translateX}%)`,
                transition: "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.4s ease-out",
                opacity: opacity,
                zIndex: offset === 0 ? 1 : 0,
              }}
            >
              <img src={img} alt={props.alt || "carousel item"} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
          );
        })}
      </div>

      {/* Next Button */}
      <button
        disabled={images.length <= 1}
        onClick={next}
        className="image-carousel-button btn-right"
      >
        <img src={rightChevron} alt="next button" />
      </button>
    </section>
  );
}

export default ImageCarousel;
